export default __webpack_public_path__ + "static/media/statistics-icon.a840f185.svg";